import { adminPrefix } from "../../constants";

export const homeServicesApis = {
  FETCH_SERVICES: adminPrefix + "services",
  CREATE_SERVICE: adminPrefix + "service/create",
  UPDATE_SERVICE: adminPrefix + "service/update",
  DELETE_SERVICE: adminPrefix + "service/delete",
  UPDATE_SERVICE_STATUS: adminPrefix + "service/update-status",
};
